import * as React from "react";
function Article({ children }) {
  return /* @__PURE__ */ React.createElement("article", { className: "article" }, children);
}
export {
  Article
};
//# sourceMappingURL=Article.js.map
